"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardRandomOption = exports.BoardName = void 0;
var BoardName;
(function (BoardName) {
    BoardName["ORIGINAL"] = "tharsis";
    BoardName["HELLAS"] = "hellas";
    BoardName["ELYSIUM"] = "elysium";
    BoardName["AMAZONIS"] = "amazonis";
    BoardName["ARABIA_TERRA"] = "arabia terra";
    BoardName["VASTITAS_BOREALIS"] = "v. borealis";
    BoardName["TERRA_CIMMERIA"] = "terra cimmeria";
})(BoardName = exports.BoardName || (exports.BoardName = {}));
var BoardRandomOption;
(function (BoardRandomOption) {
    BoardRandomOption["RANDOM_OFFICIAL"] = "random official";
    BoardRandomOption["RANDOM_ALL"] = "random all";
})(BoardRandomOption = exports.BoardRandomOption || (exports.BoardRandomOption = {}));
//# sourceMappingURL=BoardName.js.map